import React, {useState} from "react";
import {AlertPopupProps, PopupProps} from "./Popup.props";
import "./style.css";

export default function Popup(props: any) {
    const [data] = useState<PopupProps | AlertPopupProps>(props.data);

    const isShortBox = () => {
        return !data.useCloseButton;
    }

    return (
        <div className="popup">
            <div className={`popup-box ${isShortBox()? "short-box" : ""} ${props.isLong ? "long" : ""}`} data-testid="popup-box">
                <div className="text">
                    {data.subject}
                </div>
                <div className="sub alert">
                    {
                        "alertMessage" in data && data.alertMessage && (
                            <>
                                <br/>{data.alertMessage}
                            </>
                        )
                    }
                </div>
                <div className="sub" data-testid="message">
                    {data.message1}
                    {
                        data.message2 && (
                            <>
                                <br/>{data.message2}
                            </>
                        )
                    }
                </div>
                <button className="active-button" onClick={data.onConfirm}>
                    {data.buttonName}
                </button>
                {
                    data.useCloseButton && (
                        <button className="close-button" onClick={data.onClose}>
                            Close
                        </button>
                    )
                }
            </div>
        </div>
    );
}